/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Cee_LookupInputs */

const cs_enum_cee_lookup = /** @type {(inputs: Enum_Cee_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exekuce (CEE)`)
};

const en_enum_cee_lookup = /** @type {(inputs: Enum_Cee_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enforcement register`)
};

/**
* | output |
* | --- |
* | "Enforcement register" |
*
* @param {Enum_Cee_LookupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_cee_lookup = /** @type {((inputs?: Enum_Cee_LookupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Cee_LookupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_cee_lookup(inputs)
	return cs_enum_cee_lookup(inputs)
});